import type { MessageType } from "@expert/shared-types";

import type { ExpertAssistMessage } from "../shared-types";

import { useTimelineStore } from "./timelineStore";

export const getLastMessage = (sessionId: string) => {
    const { messages } = useTimelineStore.getState().getTimelineState(sessionId);
    return messages.at(-1);
};

export const getLastMessageOfType = (messages: ExpertAssistMessage[], types: MessageType[]) => {
    return messages.filter((message) => types.includes(message.type)).pop()?.id;
};

export const getMessage = (sessionId: string, id: string) => {
    const { messages } = useTimelineStore.getState().getTimelineState(sessionId);
    return messages.filter((msg) => msg.id === id)?.[0];
};
